module.exports = __webpack_public_path__ + "29be6245bc1f57a9de5411f70d5c39e8.svg";